import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { semanticColors } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  inputArea: {
    display: 'flex',
    width: '100%',
    maxWidth: '600px',
    marginRight: '24px'
  },
  titleView: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden'
  },
  headerText: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    marginRight: '8px'
  },
  editButton: {
    color: semanticColors.foreground.action,
    flexShrink: 0,
    '&:disabled': {
      color: semanticColors.foreground.disabled
    }
  },
  editMenuContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%'
  },
  input: {
    flex: 1
  },
  charCounter: {
    marginLeft: '8px',
    whiteSpace: 'nowrap',
    color: semanticColors.foreground.secondary
  }
});
